<template>
  <!--
  -->
  <div class="pb50" v-loading="loading">
    <el-form size="small" ref="form" :model="form" label-width="150px" v-if="!loading">
      <!--基础设置-->
      <Basic :form="form" :positionList="positionList"></Basic>
    </el-form>

    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" @click="cancelFunc">取消</el-button>
      <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
    </div>
  </div>
</template>
<script>
import AdApi from '@/api/ad.js';
import Basic from './part/Basic.vue';
import {mergeTable} from '@/utils/table.js'
export default {
  components: {
    /*基础设置*/
    Basic,
  },
  data() {
    return {
      /*是否正在加载*/
      loading: true,
      /*表单对象*/
       form: {
        image_id: 0,
        /*名称*/
        name: '',
        /*是否生效，默认1为生效，0为不生效*/
        status: 1,
       
        /*默认排序*/
        sort: 100,
      },
       positionList: [
        {value:'supply-top',label:'门店产品列表-顶部'},
        {value:'supply-bottom',label:'门店产品列表-底部'}
        ],
       is_edit:true
    };
  },
  created() {
    /*获取列表*/
    this.form.ad_id = this.$route.query.ad_id;
    this.getData();
  },
  methods: {



    /*获取数据*/
    getData(){
      let self = this;
      self.loading = true;
      AdApi.getAd({ad_id:self.form.ad_id}, true)
        .then(res => {
          let tempForm=res.data.detail;
          tempForm.ad_id=self.form.ad_id;

          self.form=tempForm;
          self.form.file_path = tempForm.image_url;
          self.loading = false;
        })
        .catch(error => {});
    },

    /*提交表单*/
    onSubmit() {
      let self = this;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          let params = self.form;
          delete params.tableData;
          AdApi.saveAd(params, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: '恭喜你，修改成功',
                type: 'success'
              });
              self.cancelFunc();
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },



    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/plus/ad/ad/edit.vue